<template>
  <span :class="style.heading">Яндекс Метрика</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Введите id"
      description="ID счетчика"
      v-model="localIntegration.id"
    />
    <InputStyle
      size="M"
      placeholder="Введите цель"
      description="Идентификатор цели заявка"
      v-model="localIntegration.firstTarget"
      readOnly
    />
    <InputStyle
      size="M"
      placeholder="Введите цель"
      description="Идентификатор цели контакты"
      v-model="localIntegration.secondTarget"
      readOnly
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./settingIntegrations.module.scss";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {metricIntegration} from "@/page/setting/integration/IntegrationTypes";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationYandex",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integration: {
      type: Object as PropType<metricIntegration>,
      default: () => ({})
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        id: this.integration.id ?? "",
        firstTarget: "ReaddsApplication",
        secondTarget: "ReaddsQuizContacts"
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.metric;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = {
          ...this.localIntegration
        };
      } else {
        integration.integration.push({...this.localIntegration});
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          id: newVal.id || "",
          firstTarget: "ReaddsApplication",
          secondTarget: "ReaddsQuizContacts"
        };
      }
    }
  }
});
</script>
